import { createContext, useContext } from "react";

/** Open (or focus) a tab by path. path = "<view>" or "<view>?<filters>", e.g. "brands?provider=BUYME". */
export type OpenTab = (path: string, title?: string) => void;

export const OpenTabCtx = createContext<OpenTab>(() => {});
export const useOpenTab = (): OpenTab => useContext(OpenTabCtx);

/** The current tab's query params (its preset filters). Each tab provides its own. */
export const TabParamsCtx = createContext<URLSearchParams>(new URLSearchParams());
export const useTabParams = (): URLSearchParams => useContext(TabParamsCtx);
